import React from "react";

const statusColor = (s) => {
  const v = (s || "").toLowerCase();
  if (v === "good") return "#10B981";
  if (v === "fair") return "#F59E0B";
  return "#EF4444";
};

export const VideoOverlay = ({ overlay }) => {
  if (!overlay || !overlay.available) return null;
  const lines = overlay.lines || [];
  const keypoints = overlay.keypoints || [];

  return (
    <div data-testid="ai-overlay" className="absolute inset-0 pointer-events-none">
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1 1" preserveAspectRatio="none">
        {lines.map((ln, i) => (
          <polyline
            key={i}
            points={(ln.points || []).map((p) => `${p.x},${p.y}`).join(" ")}
            fill="none"
            stroke={statusColor(ln.status)}
            strokeWidth={2.5}
            strokeLinejoin="round"
            strokeLinecap="round"
            vectorEffect="non-scaling-stroke"
            opacity={0.9}
          />
        ))}
      </svg>
      {keypoints.map((k, i) => (
        <div
          key={i}
          className="absolute -translate-x-1/2 -translate-y-1/2"
          style={{ left: `${k.x * 100}%`, top: `${k.y * 100}%` }}
        >
          <div
            className="h-3 w-3 rounded-full border-2 border-white shadow"
            style={{ backgroundColor: statusColor(k.status) }}
          />
        </div>
      ))}
    </div>
  );
};
